export default __webpack_public_path__ + "static/media/skippedmeal_3@3x.633154fc.jpg";